import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

const initialState = {
    approvalCode: {
        isLoaded: false,
        isValid: false,
        value: "",
        error: ""
    },
    company: {

    },
    appointment: {

    },
    purchaseOrder: {

    },
    purchaseOrderLoading: false,
    purchaseOrderError: null,
    purchaseOrderSuccess: null,
    purchaseOrderActionType: null,
    approverId: "",
    attendanceRequest: {},
    attendanceRequestLoading: false,
    attendanceRequestError: null,
    attendanceRequestSuccess: null,
    attendanceRequestActionType: null,
    leaveRequest: {},
    leaveRequestLoading: false,
    leaveRequestError: null,
    leaveRequestSuccess: null,
    leaveRequestActionType: null,

}

export const GET_CSRF = async (service) => {
    try {
        let url = "";
        if (service === "inventory") {
            url = `${process.env.REACT_APP_INVENTORY_URL}v1/csrf`;
        } else if (service === "attendance" || service === "leave") {
            url = `${process.env.REACT_APP_ATTENDANCE_URL}v1/external/csrf`;
        } else {
            url = `${process.env.REACT_APP_VISITOR_URL}v1/csrf`;
        }

        const response = await axios.get(url, { withCredentials: true })
        if (response?.status === 200) {
            localStorage.setItem('csrfToken', response?.data?.csrf_token)
        }
    } catch (error) {
        console.log(error);
    }
}

export const startValidateExternalApprovalCode = createAsyncThunk("commonSlice/startValidateExternalApprovalCode", async (body, { dispatch, rejectWithValue }) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_VISITOR_URL}v1/externalhost/approvalcode/validate`, body, {
            headers: {
                'x-csrf-token': localStorage.getItem('csrfToken')
            },
            withCredentials: true
        })
        if (response.status === 200) {
            dispatch(setIsLoaded({ isValid: true }))
            localStorage.setItem('encryptedCode', body?.encryptedCode)
            return {
                value: response?.data?.value,
                companyLogo: response?.data?.companyLogo,
                appointment: response?.data?.appointment,
                tenantCode: response?.data?.tenantCode,
                buildingTimezone: response?.data?.buildingTimezone
            }
        }
        else {
            console.log({ response })
        }
    }
    catch (err) {
        if (err?.response?.status === 400 && err?.response?.data?.error === "Invalid csrf token") GET_CSRF()
        else dispatch(setIsLoaded({ isValid: false, error: 'Oops, the link has expired.' }))
    }
})

export const startUpdateAppointment = createAsyncThunk("commonSlice/startUpdateAppointment", async (data, { dispatch }) => {
    try {
        const response = await axios.put(`${process.env.REACT_APP_VISITOR_URL}v1/externalhost/appointment/${data?.appointmentId}?buildingId=${data?.buildingId}`, data?.bodyObj, {
            headers: {
                'x-csrf-token': localStorage.getItem('csrfToken')
            },
            withCredentials: true
        })
        if (response?.status === 200) {
            // setIsApprovalSubmitted(true)
            return response?.data
        } else {
            console.log(response)
        }
    } catch (error) {
        if (error?.response?.status === 400 && error?.response?.data?.error === "Invalid csrf token") GET_CSRF()
        else if (error?.response?.status === 401) {
            dispatch(setIsLoaded({ isValid: false, error: 'Oops, the link has expired.' }))
        }
        console.log(error)
    }
})

export const startValidateExternalApprovalCodeInventory = createAsyncThunk("commonSlice/startValidateExternalApprovalCodeInventory", async (body, { dispatch, rejectWithValue }) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_INVENTORY_URL}v1/externalhost/approvalcode/validate`, body, {
            headers: {
                'x-csrf-token': localStorage.getItem('csrfToken')
            },
            withCredentials: true
        })

        if (response.status === 200) {
            dispatch(setIsLoaded({ isValid: true }))
            localStorage.setItem('encryptedCodeInventory', body?.encryptedCode)
            return response?.data
        }
        else {
            console.log({ response })
        }
    }
    catch (err) {
        if (err?.response?.status === 400 && err?.response?.data?.error === "Invalid csrf token") GET_CSRF()
        else dispatch(setIsLoaded({ isValid: false, error: err?.response?.data?.error || 'Oops, the link has expired.' }))
    }
})

export const startValidatePurchaseOrder = createAsyncThunk("commonSlice/startValidatePurchaseOrder", async (data, { dispatch, rejectWithValue }) => {
    try {
        const response = await axios.put(`${process.env.REACT_APP_INVENTORY_URL}v1/externalhost/validatePurchaseOrder/${data?.purchaseOrderId}?buildingId=${data?.buildingId}`, data?.body, {
            headers: {
                'x-csrf-token': localStorage.getItem('csrfToken')
            },
            withCredentials: true
        })
        if (response?.status === 200) {
            return response?.data
        } else {
            return rejectWithValue(response?.data?.message || 'Something went wrong')
        }
    } catch (error) {
        if (error?.response?.status === 400 && error?.response?.data?.error === "Invalid csrf token") {
            GET_CSRF()
            return rejectWithValue('Invalid CSRF token. Please refresh and try again.')
        }
        else if (error?.response?.status === 401) {
            dispatch(setIsLoaded({ isValid: false, error: 'Oops, the link has expired.' }))
            return rejectWithValue('The link has expired.')
        }
        console.log(error)
        return rejectWithValue(error?.response?.data?.message || error?.message || 'An error occurred')
    }
})


// Attendance Approval
export const startValidateExternalApprovalCodeAttendance = createAsyncThunk("commonSlice/startValidateExternalApprovalCodeAttendance", async (body, { dispatch, rejectWithValue }) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_ATTENDANCE_URL}v1/external/approvalcode/validate`, body, {
            headers: {
                'x-csrf-token': localStorage.getItem('csrfToken')
            },
            withCredentials: true
        })
        if (response.status === 200) {
            dispatch(setIsLoaded({ isValid: true }))
            localStorage.setItem('encryptedCodeAttendance', body?.encryptedCode)
            return response?.data
        }
        return null
    } catch (err) {
        if (err?.response?.status === 400 && err?.response?.data?.error === "Invalid csrf token") GET_CSRF()
        else dispatch(setIsLoaded({ isValid: false, error: err?.response?.data?.error || 'Oops, the link has expired.' }))
        return rejectWithValue(err?.response?.data?.error)
    }
})

export const startValidateAttendanceRequest = createAsyncThunk("commonSlice/startValidateAttendanceRequest", async (data, { dispatch, rejectWithValue }) => {
    try {
        const { attendanceApprovalId, body } = data
        const response = await axios.put(
            `${process.env.REACT_APP_ATTENDANCE_URL}v1/external/validate-attendance/${attendanceApprovalId}`,
            body,
            {
                headers: { 'x-csrf-token': localStorage.getItem('csrfToken') },
                withCredentials: true
            }
        )
        if (response?.status === 200) {
            return { ...response?.data, actionType: body?.status }
        } else {
            return rejectWithValue(response?.data?.message || 'Something went wrong')
        }
    } catch (error) {
        if (error?.response?.status === 400 && error?.response?.data?.error === "Invalid csrf token") {
            GET_CSRF("attendance")
            return rejectWithValue('Invalid CSRF token. Please refresh and try again.')
        }
        else if (error?.response?.status === 401) {
            dispatch(setIsLoaded({ isValid: false, error: 'Oops, the link has expired.' }))
            return rejectWithValue('The link has expired.')
        }
        return rejectWithValue(error?.response?.data?.message || error?.message || 'An error occurred')
    }
})

// Leave Approval
export const startValidateExternalApprovalCodeLeave = createAsyncThunk("commonSlice/startValidateExternalApprovalCodeLeave", async (body, { dispatch, rejectWithValue }) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_ATTENDANCE_URL}v1/external/approvalcode/validate-leave`, body, {
            headers: {
                'x-csrf-token': localStorage.getItem('csrfToken')
            },
            withCredentials: true
        })
        if (response.status === 200) {
            dispatch(setIsLoaded({ isValid: true }))
            localStorage.setItem('encryptedCodeLeave', body?.encryptedCode)
            return response?.data
        }
        return null
    } catch (err) {
        if (err?.response?.status === 400 && err?.response?.data?.error === "Invalid csrf token") GET_CSRF("leave")
        else dispatch(setIsLoaded({ isValid: false, error: err?.response?.data?.error || 'Oops, the link has expired.' }))
        return rejectWithValue(err?.response?.data?.error)
    }
})

export const startValidateLeaveRequest = createAsyncThunk("commonSlice/startValidateLeaveRequest", async (data, { dispatch, rejectWithValue }) => {
    try {
        const { batchId, body } = data
        const response = await axios.put(
            `${process.env.REACT_APP_ATTENDANCE_URL}v1/external/validate-leave/${batchId}`,
            body,
            {
                headers: { 'x-csrf-token': localStorage.getItem('csrfToken') },
                withCredentials: true
            }
        )
        if (response?.status === 200) {
            return { ...response?.data, actionType: body?.status }
        }
        return rejectWithValue(response?.data?.message || 'Something went wrong')
    } catch (error) {
        if (error?.response?.status === 400 && error?.response?.data?.error === "Invalid csrf token") {
            GET_CSRF("leave")
            return rejectWithValue('Invalid CSRF token. Please refresh and try again.')
        }
        else if (error?.response?.status === 401) {
            dispatch(setIsLoaded({ isValid: false, error: 'Oops, the link has expired.' }))
            return rejectWithValue('The link has expired.')
        }
        return rejectWithValue(error?.response?.data?.error || error?.response?.data?.message || error?.message || 'An error occurred')
    }
})


const commonSlice = createSlice({
    name: 'commonSlice',
    initialState,
    reducers: {
        setIsLoaded: (state, action) => {
            state.approvalCode.isLoaded = true
            state.approvalCode.isValid = action.payload?.isValid
            state.approvalCode.error = action.payload?.error
        }
    },
    extraReducers(builder) {
        builder.addCase(startValidateExternalApprovalCode.fulfilled, (state, action) => {
            if (action.payload) {
                state.approvalCode.value = action.payload?.value
                state.company.logo = action.payload?.companyLogo
                state.company.tenantCode = action.payload?.tenantCode
                state.appointment = action.payload?.appointment
                state.buildingTimezone = action.payload?.buildingTimezone
            }

        })
        builder.addCase(startUpdateAppointment.fulfilled, (state, action) => {
            if (action.payload) {
                state.appointment = action.payload
            }

        })
        builder.addCase(startValidateExternalApprovalCodeAttendance.fulfilled, (state, action) => {
            if (action.payload) {
                state.approvalCode.value = action.payload?.value
                state.attendanceRequest = action.payload?.attendanceApproval ?? action.payload?.attendanceRequest ?? action.payload
                state.buildingTimezone = action.payload?.timezone ?? action.payload?.buildingTimezone
                state.company.logo = action.payload?.companyLogo
                state.company.tenantCode = action.payload?.tenantCode ?? action.payload?.tenantId
                state.company.bid = action.payload?.bid
            }
        })
        builder.addCase(startValidateExternalApprovalCodeInventory.fulfilled, (state, action) => {
            if (action.payload) {
                state.approvalCode.value = action.payload?.value
                state.purchaseOrder = action.payload?.purchaseOrder
                state.approverId = action.payload?.approverId
                state.buildingTimezone = action.payload?.buildingTimezone
                state.buildingId = action.payload?.buildingId
                state.company.logo = action.payload?.companyLogo
            }
        })
        builder.addCase(startValidatePurchaseOrder.pending, (state, action) => {
            state.purchaseOrderLoading = true
            state.purchaseOrderError = null
            state.purchaseOrderSuccess = null
            state.purchaseOrderActionType = action.meta?.arg?.body?.actionType || null
        })
        builder.addCase(startValidatePurchaseOrder.fulfilled, (state, action) => {
            state.purchaseOrderLoading = false
            if (action.payload) {
                // If the payload contains a purchaseOrder object, use it
                // Otherwise, keep the existing purchaseOrder and just show the success message
                if (action.payload.purchaseOrder) {
                    state.purchaseOrder = action.payload.purchaseOrder
                }
                state.purchaseOrderSuccess = action.payload.message || 'Purchase order updated successfully'
            }
        })
        builder.addCase(startValidatePurchaseOrder.rejected, (state, action) => {
            state.purchaseOrderLoading = false
            state.purchaseOrderError = action.payload || action.error.message || 'An error occurred'
            state.purchaseOrderSuccess = null
            state.purchaseOrderActionType = null
        })
        builder.addCase(startValidateAttendanceRequest.pending, (state, action) => {
            state.attendanceRequestLoading = true
            state.attendanceRequestError = null
            state.attendanceRequestSuccess = null
            state.attendanceRequestActionType = action.meta?.arg?.body?.status || null
        })
        builder.addCase(startValidateAttendanceRequest.fulfilled, (state, action) => {
            state.attendanceRequestLoading = false
            if (action.payload) {
                const updated = action.payload?.attendanceApproval ?? action.payload?.attendanceRequest
                if (updated) {
                    state.attendanceRequest = updated
                }
                state.attendanceRequestSuccess = action.payload?.message || 'Request updated successfully'
                state.attendanceRequestActionType = action.payload?.actionType || null
            }
        })
        builder.addCase(startValidateAttendanceRequest.rejected, (state, action) => {
            state.attendanceRequestLoading = false
            state.attendanceRequestError = action.payload || action.error?.message || 'An error occurred'
            state.attendanceRequestSuccess = null
            state.attendanceRequestActionType = null
        })
        builder.addCase(startValidateExternalApprovalCodeLeave.fulfilled, (state, action) => {
            if (action.payload) {
                state.approvalCode.value = action.payload?.value
                state.leaveRequest = action.payload?.leaveRequest ?? action.payload
                state.buildingTimezone = action.payload?.timezone ?? action.payload?.buildingTimezone
                state.company.logo = action.payload?.companyLogo
                state.company.tenantCode = action.payload?.tenantCode ?? action.payload?.tenantId
                state.company.bid = action.payload?.bid
            }
        })
        builder.addCase(startValidateLeaveRequest.pending, (state, action) => {
            state.leaveRequestLoading = true
            state.leaveRequestError = null
            state.leaveRequestSuccess = null
            state.leaveRequestActionType = action.meta?.arg?.body?.status || null
        })
        builder.addCase(startValidateLeaveRequest.fulfilled, (state, action) => {
            state.leaveRequestLoading = false
            if (action.payload) {
                if (action.payload?.leaveRequest) {
                    state.leaveRequest = action.payload.leaveRequest
                }
                state.leaveRequestSuccess = action.payload?.message || 'Request updated successfully'
                state.leaveRequestActionType = action.payload?.actionType || null
            }
        })
        builder.addCase(startValidateLeaveRequest.rejected, (state, action) => {
            state.leaveRequestLoading = false
            state.leaveRequestError = action.payload || action.error?.message || 'An error occurred'
            state.leaveRequestSuccess = null
            state.leaveRequestActionType = null
        })
    }
})

export const { setIsLoaded } = commonSlice.actions

export default commonSlice.reducer
